import React from 'react';
import { MediaPlaceholder } from './MediaPlaceholder';
interface TestimonialsProps {
  onOpenPopup: () => void;
}
export function Testimonials({
  onOpenPopup
}: TestimonialsProps) {
  // Array de placeholders para los videos de testimonios (9 videos como en la imagen)
  const testimonials = Array.from({
    length: 9
  }, (_, i) => i + 1);
  return <section className="py-20 bg-black" data-id="element-98">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-99">
        <div className="text-center max-w-4xl mx-auto mb-16" data-id="element-100">
          <h2 className="text-3xl md:text-4xl font-bold mb-6 uppercase tracking-wide" data-id="element-101">
            CASOS DE ÉXITO
          </h2>
          <p className="text-gray-300 text-lg" data-id="element-102">
            Alumnos que ya venden sus Ebooks. Mirá más en mi{' '}
            <a href="https://instagram.com/tomasbenaviidez" target="_blank" rel="noopener noreferrer" className="underline hover:text-brand-orange transition-colors" data-id="element-103">
              instagram
            </a>{' '}
            <strong className="text-white" data-id="element-104">@tomasbenaviidez</strong>, generando
            entre $2.000 y $10.000 USD al mes
          </p>
        </div>

        {/* Capturas de pantalla de resultados (Placeholder) */}
        <div className="max-w-5xl mx-auto mb-16" data-id="element-105">
          <MediaPlaceholder type="image" text="[Imagen de Capturas de Pantalla de Resultados (Ej: Stripe, Hotmart)]" className="w-full aspect-[21/9] bg-brand-dark" data-id="element-106" />
        </div>

        {/* Grid de Videos de Testimonios */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto mb-16" data-id="element-107">
          {testimonials.map(id => <div key={id} className="relative aspect-video bg-brand-dark rounded-lg overflow-hidden border border-gray-800 group cursor-pointer hover:border-brand-orange transition-colors" data-id="element-108">
              {/*
               NOTA: Reemplazar este MediaPlaceholder con el embed de YouTube o etiqueta <video>
               */}
              <MediaPlaceholder type="video" text={`[Video Testimonio ${id}]`} className="w-full h-full border-none rounded-none" data-id="element-109" />

              {/* Fake YouTube Play Button Overlay (just for visual effect on placeholder) */}
              <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-110">
                <div className="w-12 h-8 bg-red-600 rounded-lg flex items-center justify-center opacity-80 group-hover:opacity-100 transition-opacity" data-id="element-111">
                  <div className="w-0 h-0 border-t-4 border-t-transparent border-l-[6px] border-l-white border-b-4 border-b-transparent ml-1" data-id="element-112" />
                </div>
              </div>
            </div>)}
        </div>

        <div className="flex justify-center" data-id="element-113">
          <button onClick={onOpenPopup} className="px-8 py-4 bg-brand-orange hover:bg-red-600 text-white text-lg font-bold rounded-lg transition-all transform hover:scale-105 active:scale-95 box-glow" data-id="element-114">
            ACCEDER AL CURSO GRATIS
          </button>
        </div>
      </div>
    </section>;
}